export enum StateStrategy {
  RouterConnected = 'routerConnected',
  Controlled = 'controlled',
}
